<template>
  <div
    :class="[
      'flex',
      {
        'items-center justify-center': layout.includes('center'),
        'flex-grow flex-col': layout.includes('grow'),
        'h-full flex-col': layout.includes('full'),
      },
    ]"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
  /**
   * Create a container with common flexbox properties.
   */
  type position = 'center' | 'grow' | 'default' | 'full';
  export interface MContainerProps {
    layout?: position | position[];
  }

  withDefaults(defineProps<MContainerProps>(), {
    layout: 'center',
  });
</script>
